// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import type { ThemeDefinition } from 'vuetify'
import { createVuetify } from 'vuetify'
import { en, es, fr, pt } from 'vuetify/locale'

const dark: ThemeDefinition = {
  dark: true,
  colors: {
    'dark-color': '#1f1f1f',
    background: '#2f2f2f',
    'on-background': '#ffffff',
    surface: '#242424',
    'surface-light': '#4c4c4c',
    primary: '#669fba',
    'grey-color': '#747474',
    'orange-color': '#cf9b60',
    'light-grey-color': '#c0bfbf',
    'yellow-color': '#ffeb3b',
    lighten: '#ffffff',
    success: '#7fa15c',
    error: '#c35050',
    component: '#1f1f1f'
  }
}

const light: ThemeDefinition = {
  dark: false,
  colors: {
    'dark-color': '#eeeeee',
    background: '#cccccc',
    'on-background': '#1c1c1c',
    surface: '#eeeeee',
    'surface-light': '#cccccc',
    primary: '#3da7da',
    'grey-color': '#acacac',
    'orange-color': '#e49236',
    'light-grey-color': '#636363',
    'yellow-color': '#f6ae13',
    lighten: '#1c1c1c',
    success: '#87b657',
    error: '#e44c4c',
    component: '#ffffff'
  }
}

export default createVuetify({
  // Component texts and calendar names; the language is chosen where a component needs it (v-locale-provider)
  locale: { messages: { en, es, fr, pt } },
  theme: {
    defaultTheme: 'light',
    themes: {
      dark,
      light
    }
  }
})
